export default __webpack_public_path__ + "static/media/ic_timer.5402c599.svg";